<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="8" fill="#FFCC49" />
    <path
      d="M19.0319 6.67572H11.8026C10.5411 6.67572 9.51843 7.66716 9.51843 8.89015V15.8988C9.51843 17.1218 10.5411 18.1133 11.8026 18.1133H19.0319C20.2934 18.1133 21.316 17.1218 21.316 15.8988V8.89015C21.316 7.66716 20.2934 6.67572 19.0319 6.67572Z"
      fill="url(#paint0_radial_1479_27455)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9591 11.1157V6.41669L11.5329 6.42111C10.9271 6.42111 10.3462 6.65442 9.91779 7.06971C9.48943 7.48499 9.24878 8.04824 9.24878 8.63555V11.9572H14.0912C14.0912 11.9107 13.4059 10.4514 13.4059 10.4514C13.4059 10.4514 14.9112 11.1002 14.9591 11.1157ZM21.5833 11.9528V8.63112C21.5833 8.33995 21.5241 8.05163 21.409 7.78267C21.2939 7.51371 21.1253 7.2694 20.9127 7.06371C20.7001 6.85803 20.4478 6.695 20.1701 6.58398C19.8925 6.47296 19.595 6.41611 19.2946 6.41669H15.8684V11.1113L17.4216 10.447L16.7364 11.9528H21.5833ZM14.9591 13.6777V18.3767H11.5329C10.9271 18.3767 10.3462 18.1434 9.91779 17.7281C9.48943 17.3129 9.24878 16.7496 9.24878 16.1623V12.8407H14.0957C14.0797 12.8872 13.4105 14.3465 13.4105 14.3465C13.4105 14.3465 14.9112 13.691 14.9591 13.6777ZM21.5831 16.1602V12.8386L16.7408 12.8364C16.7408 12.8829 17.426 14.3422 17.426 14.3422C17.426 14.3422 15.9208 13.6934 15.8728 13.6779V18.3747H19.299C19.9048 18.3747 20.4858 18.1414 20.9141 17.7261C21.3425 17.3108 21.5831 16.7476 21.5831 16.1602Z"
      fill="url(#paint1_linear_1479_27455)"
    />
    <path
      d="M11.5331 19.2582H14.9593V19.3689C14.9593 19.9562 14.7187 20.5195 14.2903 20.9347C13.8619 21.35 13.281 21.5833 12.6752 21.5833H9.61442C8.76632 21.5833 7.95293 21.2567 7.35323 20.6753C6.75353 20.0939 6.41663 19.3054 6.41663 18.4831V15.0508C6.41669 14.5249 6.60976 14.0163 6.9613 13.6158C7.31284 13.2154 7.79989 12.9492 8.3353 12.8651V16.158C8.3353 16.9802 8.67221 17.7687 9.27191 18.3501C9.87162 18.9315 10.685 19.2582 11.5331 19.2582Z"
      fill="url(#paint2_linear_1479_27455)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1479_27455"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.4172 12.3945) scale(5.89879 5.73129)"
      >
        <stop offset="0.35" stop-color="white" />
        <stop offset="0.61" stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_1479_27455"
        x1="10.7155"
        y1="8.05123"
        x2="19.2804"
        y2="20.4647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#212121" />
        <stop offset="0.96" stop-color="#434343" />
        <stop offset="1" stop-color="#444444" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1479_27455"
        x1="8.5991"
        y1="19.3151"
        x2="34.6635"
        y2="7.26617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.61785" stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
    </defs>
  </svg>
</template>
